export const GET_SOCIAL_CONFIG = 'GET_SOCIAL_CONFIG';
export const SAVE_SOCIAL_CONFIG = 'SAVE_SOCIAL_CONFIG';
export const SET_SOCIAL_CONFIG = 'SET_SOCIAL_CONFIG';

export const GET_VENDOR_SOCIAL_CONTENT = 'GET_VENDOR_SOCIAL_CONTENT';
export const SET_VENDOR_SOCIAL_CONTENT = 'SET_VENDOR_SOCIAL_CONTENT';

export const GET_VENDOR_SOCIAL_POSTS = 'GET_VENDOR_SOCIAL_POSTS';
export const SET_VENDOR_SOCIAL_POSTS = 'SET_VENDOR_SOCIAL_POSTS';

export const CREATE_VENDOR_SOCIAL_POST = 'CREATE_VENDOR_SOCIAL_POST';
export const UPDATE_VENDOR_SOCIAL_POST = 'UPDATE_VENDOR_SOCIAL_POST';
export const DELETE_VENDOR_SOCIAL_POST = 'DELETE_VENDOR_SOCIAL_POST';
export const PUSH_VENDOR_SOCIAL_POST_NOW =
  'PUSH_VENDOR_SOCIAL_POST_NOW';

export const SET_SOCIAL_STATUS = 'SET_SOCIAL_STATUS';
